import Event, { EventSwitch } from './event/Event'
import ExitEvent from './ExitEvent'

export {
  Event,
  EventSwitch
}

export const Events = {
  Exit: ExitEvent
}


// WEBPACK FOOTER //
// ./src/components/events/index.js